import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { initCoaTableScrollShadow } from "./pages/Report/utils/coaTableScrollShadow";

//#region Common
import Forgotpassword from "./pages/common/forgotpassword/forgotpasswordform";
import Login from "./pages/common/login/login";
import Logout from "./pages/common/logout/Logout";
import OTPverification from "./pages/common/otpverification/otpverificationform";
import Resetpassword from "./pages/common/resetpassword/resetpassword";
//#endregion

//#region Dashboard
import CfcDashboard from "./pages/Dashboard/CfcDashboard";
import Dashboard from "./pages/Dashboard/Dashboard";
import FieldOfficeDashboard from "./pages/Dashboard/FieldOfficeDashboard";
//#endregion

//#region General Services

//#region New Connection
import NewConnectionForm from "./pages/GeneralServices/NewConnection/NewConnectionForm";
import NewConnectionTable from './pages/GeneralServices/NewConnection/NewConnectionTable';
import Newconnectionupdatedocuments from "./pages/GeneralServices/NewConnection/NewConnectionUpdateDocuments";
import NewconnectionReports from "./pages/Report/NewConnectionReports";
//#endregion

//#region Change of Attributes
import ChangeOfAttributesForm from "./pages/GeneralServices/ChangeOfAttributes/ChangeOfAttributesForm";
import ChangeOfLoadTable from "./pages/GeneralServices/ChangeOfLoad/ChangeOfLoadTable";
import Changeofloadupdatedocuments from "./pages/GeneralServices/ChangeOfLoad/ChangeOfLoadUpdateDocuments";
import ChangeAttributesTable from "./pages/GeneralServices/ChangeOfAttribute/ChangeAttributesTable";
import ChangeofAttributesupdatedocuments from "./pages/GeneralServices/ChangeOfAttribute/ChangeOfAttributesUpdateDocuments";
import ChangeOfTariffTable from "./pages/GeneralServices/ChangeOfTariff/ChangeOfTariffTable";
import Changeoftariffupdatedocuments from "./pages/GeneralServices/ChangeOfTariff/ChangeOfTariffUpdateDocuments";
//#endregion

//#region Tenant CNIC Updation
import CNICUpdation from "./pages/GeneralServices/TenantCnicUpdation/TenantCnicUpdation";
//#endregion

//#region Opt for Smart Meter
import OptForSmartMeterForm from './pages/GeneralServices/OptForSmartMeter/OptForSmartMeterForm';
import OptForSmartMeterTable from './pages/GeneralServices/OptForSmartMeter/OptForSmartMeterTable';
import Optforsmartmeterupdatedocuments from './pages/GeneralServices/OptForSmartMeter/OptForSmartMeterUpdateDocuments';
//#endregion

//#region Opt for Smart Meter
import ShiftingToNetMeterForm from './pages/GeneralServices/ShiftingToNetMeter/ShiftingToNetMeterForm';
import ShiftingToNetMeterTable from './pages/GeneralServices/ShiftingToNetMeter/ShiftingToNetMeterTable';

import MeterChangeRequestForm from "./pages/BillingAndCollection/MeterChangeRequest/MeterChangeRequestForm";
import MeterChangeRequestTable from "./pages/BillingAndCollection/MeterChangeRequest/MeterChangeRequestTable";
import MeterChangeRequestUpdateDocuments from "./pages/BillingAndCollection/MeterChangeRequest/MeterChangeRequestUpdateDocuments";

import MeterReadingCorrectionForm from "./pages/BillingAndCollection/MeterReadingCorrection/MeterReadingCorrectionForm";
import MeterReadingCorrectionTable from "./pages/BillingAndCollection/MeterReadingCorrection/MeterReadingCorrectionTable";
import MeterReadingCorrectionUpdateImages from "./pages/BillingAndCollection/MeterReadingCorrection/MeterReadingCorrectionUpdateImages";
import MeterReadingCorrectionReports from "./pages/Report/MeterReadingCorrectionReports";

//#endregion

//#region Due Date Extension
import DueDateExtensionForm from "./pages/BillingAndCollection/DueDateExtentsion/DueDateExtensionForm";
import DueDateExtensionTable from "./pages/BillingAndCollection/DueDateExtentsion/DueDateExtensionTable";
import DueDateExtensionReport from "./pages/Report/DueDateExtensionReports";
//#endregion

//#region Duplicate Bill
import DuplicateBill from "./pages/BillingAndCollection/DuplicateBill/DuplicateBill";
//#endregion

//#region Installments
import InstallmentsForm from "./pages/BillingAndCollection/Installments/InstallmentsForm";
import InstallmentsTable from "./pages/BillingAndCollection/Installments/InstallmentsTable";
import InstallmentsReports from "./pages/Report/InstallmentsReports";

//#endregion

//#endregion

//#region Power Complaints

//#region Complaints
import ComplaintsGIS from "./pages/PowerComplaints/Complaints/ComplaintsGIS";
import PowerComplianTable from "./pages/PowerComplaints/Complaints/PowerComplainTable";
import Powercomplaintsform from "./pages/PowerComplaints/Complaints/PowerComplaintsForm";
import PowercomplaintsTrack from "./pages/PowerComplaints/Complaints/PowerComplaintsTrack";
//#endregion

//#region Load Management Schecule
import LoadManagement from "./pages/PowerComplaints/LoadManagementSchedule/LoadManagement";
//#endregion

//#endregion

//#region AccessManagement

//#region RoleManagement
import RoleCreationForm from "./pages/AccessManagement/RoleManagement/create-role/RoleCreationForm";
import RoleManagementTable from "./pages/AccessManagement/RoleManagement/RoleManagementTable";
import RoleUpdateForm from "./pages/AccessManagement/RoleManagement/update-role/RoleUpdateForm";
//#endregion

//#region UserManagement
import UserCreateForm from "./pages/AccessManagement/UserManagement/create-user/CreateUser";
import UserUpdateForm from "./pages/AccessManagement/UserManagement/update-user/UpdateUser";
import UserManagementTable from "./pages/AccessManagement/UserManagement/UserManagement";
//#endregion

//#region Permission Management
import CreatePermissson from "./pages/AccessManagement/PermissionsManagement/create-permission/CreatePermissson";
import PermissionManagementTable from "./pages/AccessManagement/PermissionsManagement/PermissionManagementTable";
import EopsUpdates from "./pages/AccessManagement/EopsUpdates/EopsUpdates";
//#endregion

//#endregion

//#region Organization Management

//#region Company Management
import CompanyManagementTable from "./pages/OrganizationManagement/CompanyManagement/CompanyManagement";
import CompanyCreateForm from "./pages/OrganizationManagement/CompanyManagement/CreateCompany/CreateCompany";
import CompanyUpdateForm from "./pages/OrganizationManagement/CompanyManagement/UpdateCompany/UpdateCompany";
//#endregion

//#region Circle Management
import CircleManagementTable from "./pages/OrganizationManagement/CircleManagement/CircleManagement";
import CircleCreateForm from "./pages/OrganizationManagement/CircleManagement/CreateCircle/CreateCircle";
import CircleUpdateForm from "./pages/OrganizationManagement/CircleManagement/UpdateCircle/UpdateCircle";
//#endregion

//#region Division Management
import DivisionCreateForm from "./pages/OrganizationManagement/DivisionManagement/CreateDivision/CreateDivision";
import DivisionManagementTable from "./pages/OrganizationManagement/DivisionManagement/DivisionManagement";
import DivisionUpdateForm from "./pages/OrganizationManagement/DivisionManagement/UpdateDivision/UpdateDivision";
//#endregion

//#region SupportCenterManagement
import SupportCenterCreateForm from "./pages/OrganizationManagement/SupportCenterManagement/create-support-center/CreateSupportCenter";
import SupporCenterManagementTable from "./pages/OrganizationManagement/SupportCenterManagement/SupportCenterManagementTable";
import SupportCenterUpdateForm from "./pages/OrganizationManagement/SupportCenterManagement/update-support-center/UpdateCenterManagement";
//#endregion

//#region Division Management
import SubDivisionCreateForm from "./pages/OrganizationManagement/SubDivisionManagement/CreateSubDivision/CreateSubDivision";
import SubDivisionManagementTable from "./pages/OrganizationManagement/SubDivisionManagement/SubDivisionManagement";
import SubDivisionUpdateForm from "./pages/OrganizationManagement/SubDivisionManagement/UpdateSubDivision/UpdateSubDivision";


import ProtectedRoutes from "./protectedroute";

import { Grid } from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SetAsideForm from "./pages/BillingAndCollection/SetAside/SetAsideForm";
import SetAsideTable from "./pages/BillingAndCollection/SetAside/SetAsideTable";
import ActionablesTable from "./pages/common/ActionablesTable/ActionablesTable";
import LoggedInUsers from "./pages/common/loggedInUsers/loggedInUsers";
import CommercialOperations from "./pages/Dashboard/CommercialOperations";
import HierarchicalDashboard from "./pages/Dashboard/HierarchicalDashboard";
import TechnicalOperations from "./pages/Dashboard/TechinalOperations";
import APMSDashboard from "./pages/Dashboard/APMSDashboard";
import LandingPage from "./pages/Dashboard/LandingPage";
import BillCorrectionForm from "./pages/GeneralServices/Bill Correction/BillCorrectionForm";
import BillCorrectionTable from "./pages/GeneralServices/Bill Correction/BillCorrectionTable";
import ReconnectionForm from "./pages/GeneralServices/Reconnection/ReconnectionForm";
import Reconnectiontable from "./pages/GeneralServices/Reconnection/ReconnectionTable";
import ReconnectionUpdate from "./pages/GeneralServices/Reconnection/ReconnectionUpdateDocuments";
import AllocatedComplaints from "./pages/PowerComplaints/Complaints/AllocatedComplaints";
import ComplaintsSummary from "./pages/PowerComplaints/Complaints/ComplaintsSummary";
import DetailReport from "./pages/PowerComplaints/Complaints/DetailReport";
import DisplayComplaintGIS from "./pages/PowerComplaints/Complaints/DisplayComplaintGIS";
import EscalatedComplaints from "./pages/PowerComplaints/Complaints/EscalatedComplaints";
import APMSEscalatedComplaints from "./pages/PowerComplaints/Complaints/APMSEscalatedComplaints";
import APMSComplaintsSummary from "./pages/PowerComplaints/Complaints/APMSComplaintsSummary";
import LinemanAPPUserSummary from "./pages/PowerComplaints/Complaints/LinemanAPPUserSummary";
import LinemanStaffPerformance from "./pages/PowerComplaints/Complaints/LineStaffPerformance";
import OnHoldCompliants from "./pages/PowerComplaints/Complaints/OnHoldComplaints";
import PendingCompliants from "./pages/PowerComplaints/Complaints/PendingComplaints";
import PendingEscalatedTable from "./pages/PowerComplaints/Complaints/PendingEscalatedComplaints";
import ResolvedComplaints from "./pages/PowerComplaints/Complaints/ResolvedComplaints";
import WorkingComplaints from "./pages/PowerComplaints/Complaints/WorkingComplaints";
import BatchWiseAssessmentReport from "./pages/Report/BatchWiseAssessmentReport";
import CashCollectionSummaryReport from "./pages/Report/CashCollectionSummaryReport";
import DailyProgressReport from "./pages/Report/DailyProgressReport";
import DeadDefaulterList from "./pages/Report/DeadDefaulterList";
import FeederLossesReport from "./pages/Report/FeederLossesReport";
import NewConnectionExceededApplicationSummary from "./pages/Report/NewConnectionExceededApplicationSummary";
import NewConnectionPostedToIBSReport from "./pages/Report/NewConnectionPostedToIBSReport";
import TariffWiseAnalysisOfBillingAndCollectionReport from "./pages/Report/TariffWiseAnalysisOfBillingAndCollectionReport";
import PermissionRoute from "./PermissionRoute";
import useInactivityLogout from "./services/UserInactivity";
import EopsMobileAppUsageSummary from "./pages/PowerComplaints/Complaints/EopsMobileAppUsageSummary";
import NotLoggedInUserInLast24Hours from "./pages/PowerComplaints/Complaints/NotLoggedInUserInLast24Hours";

import { resetState as resetStateDueDate } from "./features/billingAndCollection/dueDateExtensionOverdueSlice";
import { resetState as resetStateInstallmentsNormal } from "./features/billingAndCollection/installmentsNormalSlice";
import { resetState as resetStateInstallmentsOverdue } from "./features/billingAndCollection/installmentsOverdueSlice";
import { resetOverallPerformanceState } from "./features/dashboard/overallPerformance";


import { resetState as resetStateColNormal } from "./features/generalServices/colNormalSlice";
import { resetState as resetStateColOverdue } from "./features/generalServices/colOverdueSlice";
import { resetState as resetStateConNormal } from "./features/generalServices/coaNormalSlice";
import { resetState as resetStateConOverdue } from "./features/generalServices/coaOverdueSlice";
import { resetState as resetStateCotNormal } from "./features/generalServices/cotNormalSlice";
import { resetState as resetStateCotOverdue } from "./features/generalServices/cotOverdueSlice";
import { resetState as resetStateNcNormal } from "./features/generalServices/ncNormalSlice";


import { fetchFeederStatus, resetFeederStatusState } from "./features/geoJson/feedersStatus";
import { signOut, updateEmail, updateName, updatePhone, updateProfilePicture } from "./features/authentication/authenticationSlice";
import { allStatsAPI, removeStats } from "./features/stats/statsSlice";
// import { fetchPaginatedAllComplaints, resetState as resetStateAllComplaints } from "./features/powerComplaints/getComplaintSlice";
import { fetchPaginatedAllComplaints, resetState as resetStateAllComplaints } from "./features/powerComplaints/getComplaintSlice";

import { fetchGeoJson, resetGeoJsonState } from "./features/geoJson/geoJson";
// import { fetchActionable, resetActionableNormal } from "./features/generalServices/";
import { actionableOverdue, resetState as resetActionableOverdue } from "./features/actionable/actionableOverdueSlice";
import { resetState as resetStateNcOverdue } from "./features/generalServices/ncOverdueSlice";
import { actionableNormal, resetState as resetActionableNormal } from "./features/actionable/actionableNormalSlice";
import { cfpBaseUrl } from "./network/urls";
import NewConnectionStatusReport from "./pages/Report/NewConnectionStatusReport";
import MeterChangeOrderStatusReport from "./pages/Report/MeterChangeOrderStatusReport";
import EopsUsersStatus from "./pages/PowerComplaints/Complaints/EopsUsersStatus";

import MobileAppStats from "./pages/common/MobileAppStats/MobileAppStats";
import SRonEmail from "./pages/Report/SRonEmail";
import COASRonEmail from "./pages/Report/COASRonEmail";
import AmendDuplicateBill from "./pages/BillingAndCollection/DuplicateBill/AmendDuplicateBill";
import ComplaintSourceWise from "./pages/PowerComplaints/Complaints/ComplaintSourceWise";
import AdjustLastBillForm from "./pages/BillingAndCollection/AdjustLastBill/AdjustLastBillForm";
import AdjustLastBillTable from "./pages/BillingAndCollection/AdjustLastBill/AdjustLastBillTable";
import AdjustLastBillUpdateDocuments from "./pages/BillingAndCollection/AdjustLastBill/AdjustLastBillUpdateDocuments";
import TopBestAndWorstPerformer from "./pages/PowerComplaints/Complaints/TopBestAndWorstPerformer";
import AmendBill2636Form from "./pages/BillingAndCollection/AmendBill2636/AmendBill2636Form";
import AmendBill2636Table from "./pages/BillingAndCollection/AmendBill2636/AmendBill2636Table";
import PartPaymentUpdateDocuments from "./pages/BillingAndCollection/AmendBill2636/PartPaymentUpdateDocuments";
import AdvancePaymentForm from "./pages/BillingAndCollection/AdvancePayment/AdvancePaymentForm";
import AdvancePaymentTable from "./pages/BillingAndCollection/AdvancePayment/AdvancePaymentTable";
import AdvancePaymentUpdateDocuments from "./pages/BillingAndCollection/AdvancePayment/AdvancePaymentUpdateDocuments";
import NewConnectionStatusWiseCountReport from "./pages/Report/NewConnectionStatusWiseCountReport";
import ChangeOfAttributesStatusReport from "./pages/Report/ChangeOfAttributesStatusReport";
import ChangeOfAttributesPostedToIBSReport from "./pages/Report/ChangeOfAttributesPostedToIBSReport";
import ChangeOfAttributeStatusWiseCountReport from "./pages/Report/ChangeOfAttributeStatusWiseCountReport";
import COASummaryReports from "pages/Report/COASummaryReports";
import ReconnectionPostedToIBSReport from "pages/Report/ReconnectionPostedToIBSReport";

const App = () => {
  useInactivityLogout(); // Default is 30 mins

  useEffect(() => initCoaTableScrollShadow(), []);

  const {
    userId,
    cscID,
    token,
    permissions,
    code,
    hierarchy,
    showAllApplicationsFlag,
    name,
    roleName,
    profilePicture,
    roleTypeId,
    phoneNo,
    roleId,
    cnic,
    email,
    circleCode
  } = useSelector((state) => state.auth);

  // useEffect(() => {
  //   const zoom = Math.round(window.devicePixelRatio * 100); 
  //   console.log(`Zoom level: ${zoom}%`);

  //   if (zoom < 100) {
  //     alert(`You're viewing at ${zoom}%. Press *Ctrl +* on Window or *Cmd +* on Mac to zoom in to 100%.`);
  //   } else if (zoom > 100) {
  //     alert(`You're viewing at ${zoom}%. Press *Ctrl -* on Window or *Cmd -* on Mac to zoom out to 100%.`);
  //   }
  // }, []);
  /**
    * @type {string|null}
    */
  /**
     * @param {string} token 
     */
  // useTrackTabs(token); 

  /**
   * Stores the selected NC item.
   * @type {Array}
   */
  const [ncSelectedItem, setNcSelectedItem] = useState();

  /**
  * Callback function to handle NC item selection.
  * @function
  * @param {Array} NCFilteredArray - The filtered NC items.
  */
  const NCCallBack = (NCFilteredArray) => {
    setNcSelectedItem(NCFilteredArray)
  }

  const dispatch = useDispatch()


    const callLogoutAPI = async () => {
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
  
  
        const requestOptions = {
          method: "PUT",
          headers: myHeaders,
          keepalive: true,
        };
  
        await fetch(cfpBaseUrl + "customerFaciliationPortal/logOut", requestOptions)
          .then((response) => response.json())
          .then((result) => console.log(result))
          .catch((error) => console.error(error));
      } catch (e) {
  
      }
    }
  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    const storedDate = localStorage.getItem("appDate");
    if (!storedDate) {
      // localStorage.setItem("appDate", today);
      callLogoutAPI();
      dispatch(resetStateNcNormal());
      dispatch(resetStateNcOverdue());
      dispatch(resetStateConNormal());
      dispatch(resetStateConOverdue());
      dispatch(resetStateColNormal());
      dispatch(resetStateColOverdue());
      dispatch(resetStateCotNormal());
      dispatch(resetStateCotOverdue());
      dispatch(resetStateDueDate());
      dispatch(resetStateInstallmentsNormal());
      dispatch(resetStateInstallmentsOverdue());
      dispatch(removeStats());
      dispatch(resetOverallPerformanceState());
      dispatch(resetFeederStatusState());
      dispatch(resetGeoJsonState());
      dispatch(resetActionableNormal());
      dispatch(resetActionableOverdue());
      dispatch(resetStateAllComplaints());
      dispatch(signOut());
    } else if (storedDate !== today) {
      console.log("second time login: mismatch found");
      console.log("storedDate:", storedDate, "today:", today);
    
      // logout + reset
      callLogoutAPI();
      dispatch(resetStateNcNormal());
      dispatch(resetStateNcOverdue());
      dispatch(resetStateConNormal());
      dispatch(resetStateConOverdue());
      dispatch(resetStateColNormal());
      dispatch(resetStateColOverdue());
      dispatch(resetStateCotNormal());
      dispatch(resetStateCotOverdue());
      dispatch(resetStateDueDate());
      dispatch(resetStateInstallmentsNormal());
      dispatch(resetStateInstallmentsOverdue());
      dispatch(removeStats());
      dispatch(resetOverallPerformanceState());
      dispatch(resetFeederStatusState());
      dispatch(resetGeoJsonState());
      dispatch(resetActionableNormal());
      dispatch(resetActionableOverdue());
      dispatch(resetStateAllComplaints());
      dispatch(signOut());
    } 
  }, []);


  useEffect(() => {
    const checkVersion = async () => {
      try {
        const response = await fetch("/version.json", { cache: "no-store" });
        const data = await response.json();
        const currentVersion = localStorage.getItem("appVersion");
        const versionPromptShown = localStorage.getItem("versionPromptShown");
    
        if (currentVersion && currentVersion !== data.version) {
  
          if (versionPromptShown !== data.version) {
            window.alert("A new version of this app is available.\nThe app will now update.");
  
            localStorage.setItem("appVersion", data.version);
            localStorage.removeItem("versionPromptShown");
            window.location.reload(true);
          }
        } else if (!currentVersion) {
          localStorage.setItem("appVersion", data.version);
        }
      } catch (error) {
        console.error("Version check failed:", error);
      }
    };
  
    checkVersion();
  
    const interval = setInterval(checkVersion, 30000); 
    return () => clearInterval(interval);
  }, []);
  
  useEffect(() => {
    const checkVersionLogout = async () => {
      try {
        const response = await fetch("/appLogoutVersion.json", { cache: "no-store" });
        const data = await response.json();
        const currentVersion = localStorage.getItem("appLogoutVersion");

        if (currentVersion && currentVersion !== data.version) {
          window.alert("A new version of this app is available.\nYou will be logged out.");
          dispatch(resetStateNcNormal());
          dispatch(resetStateNcOverdue());
          dispatch(resetStateConNormal());
          dispatch(resetStateConOverdue());
          dispatch(resetStateColNormal());
          dispatch(resetStateColOverdue());
          dispatch(resetStateCotNormal());
          dispatch(resetStateCotOverdue());
          dispatch(resetStateDueDate());
          dispatch(resetStateInstallmentsNormal());
          dispatch(resetStateInstallmentsOverdue());
          dispatch(removeStats());
          dispatch(resetOverallPerformanceState());
          dispatch(resetFeederStatusState());
          dispatch(resetGeoJsonState());
          dispatch(resetActionableNormal());
          dispatch(resetActionableOverdue());
          dispatch(resetStateAllComplaints());

          // Clear auth state (triggers purgeMiddleware to clear persisted storage)
          dispatch(signOut());

          // Clear all browser storage
          localStorage.clear();
          sessionStorage.clear();

          // Set new version after clearing
          localStorage.setItem("appLogoutVersion", data.version);

          // Redirect to login
          window.location.href = "/";
        } else if (!currentVersion) {
          localStorage.setItem("appLogoutVersion", data.version);
        }
      } catch (error) {
        console.error("Version check failed:", error);
      }
    };

    checkVersionLogout();

    const interval = setInterval(checkVersionLogout, 30000);
    return () => clearInterval(interval);
  }, [dispatch]);

  return (
    <Grid>
      <BrowserRouter className="fullscreen-wrapper">
        <Routes>
          <Route path="/">

            <Route index element={<Login />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="forgot-password" element={<Forgotpassword />} />
            <Route path="otp-verification" element={<OTPverification />} />
            <Route path="reset-password" element={<Resetpassword />} />


            <Route element={<ProtectedRoutes handleNCClick={NCCallBack} />}>


              <Route path="role-management">
                <Route
                  index
                  element={
                    <PermissionRoute requiredPermissions={["Access Management"]}>
                      <RoleManagementTable />
                    </PermissionRoute>
                  }
                />
                <Route
                  path="new-role"
                  element={
                    <PermissionRoute requiredPermissions={["Access Management"]}>
                      <RoleCreationForm />
                    </PermissionRoute>
                  }
                />
                <Route
                  path="update-role"
                  element={
                    <PermissionRoute requiredPermissions={["Access Management"]}>
                      <RoleUpdateForm />
                    </PermissionRoute>
                  }
                />
              </Route>

              <Route path="user-management">
                <Route
                  index
                  element={
                    <PermissionRoute requiredPermissions={["Access Management"]}>
                      <UserManagementTable />
                    </PermissionRoute>
                  }
                />
                <Route
                  path="new-user"
                  element={
                    <PermissionRoute requiredPermissions={["Access Management"]}>
                      <UserCreateForm />
                    </PermissionRoute>
                  }
                />
                <Route
                  path="update-user"
                  element={
                    <PermissionRoute requiredPermissions={["Access Management"]}>
                      <UserUpdateForm />
                    </PermissionRoute>
                  }
                />
              </Route>

              <Route path="permission-management">
                <Route
                  index
                  element={
                    <PermissionRoute requiredPermissions={["Access Management > Permission Management > Read"]}>
                      <PermissionManagementTable />
                    </PermissionRoute>
                  }
                />
                <Route
                  path="new-permission"
                  element={
                    <PermissionRoute requiredPermissions={["Access Management > Permission Management > Create"]}>
                      <CreatePermissson />
                    </PermissionRoute>
                  }
                />

              </Route>

              <Route path="eops-updates" element={<EopsUpdates />} />

              <Route path="company-management">
                <Route
                  index
                  element={
                    <PermissionRoute requiredPermissions={["Organization Management"]}>
                      <CompanyManagementTable />
                    </PermissionRoute>
                  }
                />
                <Route
                  path="new-company"
                  element={
                    <PermissionRoute requiredPermissions={["Organization Management"]}>
                      <CompanyCreateForm />
                    </PermissionRoute>
                  }
                />
                <Route
                  path="update-company"
                  element={
                    <PermissionRoute requiredPermissions={["Organization Management"]}>
                      <CompanyUpdateForm />
                    </PermissionRoute>
                  }
                />
              </Route>

              <Route path="circle-management">
                <Route
                  index
                  element={
                    <PermissionRoute requiredPermissions={["Organization Management"]}>
                      <CircleManagementTable />
                    </PermissionRoute>
                  }
                />
                <Route
                  path="new-circle"
                  element={
                    <PermissionRoute requiredPermissions={["Organization Management"]}>
                      <CircleCreateForm />
                    </PermissionRoute>
                  }
                />
                <Route
                  path="update-circle"
                  element={
                    <PermissionRoute requiredPermissions={["Organization Management"]}>
                      <CircleUpdateForm />
                    </PermissionRoute>
                  }
                />
              </Route>

              <Route path="division-management">
                <Route
                  index
                  element={
                    <PermissionRoute requiredPermissions={["Organization Management"]}>
                      <DivisionManagementTable />
                    </PermissionRoute>
                  }
                />
                <Route
                  path="new-division"
                  element={
                    <PermissionRoute requiredPermissions={["Organization Management"]}>
                      <DivisionCreateForm />
                    </PermissionRoute>
                  }
                />
                <Route
                  path="update-division"
                  element={
                    <PermissionRoute requiredPermissions={["Organization Management"]}>
                      <DivisionUpdateForm />
                    </PermissionRoute>
                  }
                />
              </Route>

              <Route path="support-center-management">
                <Route
                  index
                  element={
                    <PermissionRoute requiredPermissions={["Organization Management"]}>
                      <SupporCenterManagementTable />
                    </PermissionRoute>
                  }
                />
                <Route
                  path="new-support-center"
                  element={
                    <PermissionRoute requiredPermissions={["Organization Management"]}>
                      <SupportCenterCreateForm />
                    </PermissionRoute>
                  }
                />
                <Route
                  path="UpdateCenterManagement"
                  element={
                    <PermissionRoute requiredPermissions={["Organization Management"]}>
                      <SupportCenterUpdateForm />
                    </PermissionRoute>
                  }
                />
              </Route>

              <Route path="sub-division-management">
                <Route
                  index
                  element={
                    <PermissionRoute requiredPermissions={["Organization Management"]}>
                      <SubDivisionManagementTable />
                    </PermissionRoute>
                  }
                />
                <Route
                  path="new-sub-division"
                  element={
                    <PermissionRoute requiredPermissions={["Organization Management"]}>
                      <SubDivisionCreateForm />
                    </PermissionRoute>
                  }
                />
                <Route
                  path="update-sub-division"
                  element={
                    <PermissionRoute requiredPermissions={["Organization Management"]}>
                      <SubDivisionUpdateForm />
                    </PermissionRoute>
                  }
                />
              </Route>

              {/* <Route path="company-management" >
                <Route index element={<CompanyManagementTable />} />
                <Route path='new-company' element={<CompanyCreateForm />}></Route>
                <Route path='update-company' element={<CompanyUpdateForm />}></Route>
              </Route>
              <Route path="circle-management" >
                <Route index element={<CircleManagementTable />} />
                <Route path='new-circle' element={<CircleCreateForm />}></Route>
                <Route path='update-circle' element={<CircleUpdateForm />}></Route>
              </Route>
              <Route path="division-management" >
                <Route index element={<DivisionManagementTable />} />
                <Route path='new-division' element={<DivisionCreateForm />}></Route>
                <Route path='update-division' element={<DivisionUpdateForm />}></Route>
              </Route>
              <Route path="support-center-management" >
                <Route index element={<SupporCenterManagementTable />} />
                <Route path='new-support-center' element={<SupportCenterCreateForm />}></Route>
                <Route path='UpdateCenterManagement' element={<SupportCenterUpdateForm />}></Route>
              </Route>
              <Route path="sub-division-management" >
                <Route index element={<SubDivisionManagementTable />} />
                <Route path='new-sub-division' element={<SubDivisionCreateForm />}></Route>
                <Route path='update-sub-division' element={<SubDivisionUpdateForm />}></Route>
              </Route> */}
              <Route path="landingpage" element={<LandingPage />} />
              <Route path="home" element={<Dashboard />} />
              <Route path="homecfc" element={<CfcDashboard />} />
              <Route path="homefieldoffice" element={<FieldOfficeDashboard />} />
              <Route path="operationalperformance" element={<HierarchicalDashboard />} />
              <Route path="commercialOperations" element={<CommercialOperations />} />
              <Route path="technicalOperations" element={<TechnicalOperations />} />
              <Route path="apms-dashboard" element={<APMSDashboard />} />

              <Route path="actionables-table" element={<ActionablesTable />} />
              <Route path="net-metering" >
                <Route index element={<ShiftingToNetMeterTable />} />
                <Route path='net-metering-form' element={<ShiftingToNetMeterForm />}></Route>
              </Route>
              <Route path="new-connection-table" element={<NewConnectionTable showTable={true} />} />
              <Route path="new-connection-posted-to-ibs-report" element={<NewConnectionPostedToIBSReport />} />
              <Route path="change-of-attributes-posted-to-ibs-report" element={<ChangeOfAttributesPostedToIBSReport />} />
              <Route path="new-connection-summary" element={<NewconnectionReports />} />
              <Route path="change-of-attributes-status-report" element={<ChangeOfAttributesStatusReport />} />
              <Route path="change-of-attributes-status-wise-count-report" element={<ChangeOfAttributeStatusWiseCountReport />} />
              <Route path="sr-on-email" element={<SRonEmail />} />
              <Route path="coa-sr-on-email" element={<COASRonEmail />} />
              <Route path="change-of-attributes-summary-report" element={<COASummaryReports />} />
              <Route path="reconnection-posted-to-ibs-report" element={<ReconnectionPostedToIBSReport />} />
              <Route path="new-connection-status-wise-count-report" element={<NewConnectionStatusWiseCountReport />} />
              <Route path="new-connection-subdivision-wise-applications-status-report" element={<NewConnectionExceededApplicationSummary />} />
              <Route path="new-connection-form" element={<NewConnectionForm />} />
              <Route path="new-connection-update" element={<Newconnectionupdatedocuments />} />
              <Route path="reconnection-table" element={<Reconnectiontable showTable={true} />} />
              <Route path="bill-correction-form" element={<BillCorrectionForm />} />
              <Route path="logged-in-users" element={<LoggedInUsers />} />
              <Route path="bill-correction-table" element={<BillCorrectionTable showTable={true} />} />
              <Route path="reconnection-form" element={<ReconnectionForm />} />
              <Route path="reconnection-update" element={<ReconnectionUpdate />} />
              <Route path="change-of-attributes-table" element={<ChangeAttributesTable showTable={true} />} />
              <Route path="change-of-attributes-update" element={<ChangeofAttributesupdatedocuments />} /> 
              <Route path="change-of-tariff-table" element={<ChangeOfTariffTable showTable={true} />} />
              <Route path="change-of-tariff-update" element={<Changeoftariffupdatedocuments />} />
              <Route path="change-of-load-table" element={<ChangeOfLoadTable showTable={true} />} />
              <Route path="change-of-load-update" element={<Changeofloadupdatedocuments />} />
              <Route path="change-of-attributes-form/:sourcePage" element={<ChangeOfAttributesForm />} />
              <Route path="opt-for-smart-meter-table" element={<OptForSmartMeterTable />} />
              <Route path="opt-for-smart-meter-form" element={<OptForSmartMeterForm />} />
              <Route path="opt-for-smart-meter-update" element={<Optforsmartmeterupdatedocuments />} />
              <Route path="due-date-extension-form" element={<DueDateExtensionForm />} />
              <Route path="due-date-extension-table" element={<DueDateExtensionTable showTable={true} />} />

              <Route path="adjust-last-bill-form" element={<AdjustLastBillForm />} />
              <Route path="adjust-last-bill-table" element={<AdjustLastBillTable showTable={true} />} />
              <Route path="adjust-last-bill-update" element={<AdjustLastBillUpdateDocuments />} />

              <Route path="amend-2636-bill-form" element={<AmendBill2636Form />} />
              <Route path="amend-2636-bill-table" element={<AmendBill2636Table showTable={true} />} />
              <Route path="part-payment-update" element={<PartPaymentUpdateDocuments />} />

              <Route path="advance-payment-form" element={<AdvancePaymentForm />} />
              <Route path="advance-payment-table" element={<AdvancePaymentTable showTable={true} />} />
              <Route path="advance-payment-update" element={<AdvancePaymentUpdateDocuments />} />
              {/* <Route path="amend-2636-bill-form" element={<AmendBill2636Form />} /> */}

              <Route path="due-date-extension-reports" element={<DueDateExtensionReport />} />
              <Route path="installments-form" element={<InstallmentsForm />} />
              <Route path="installments-table" element={<InstallmentsTable showTable={true} />} />
              <Route path="installments-reports" element={<InstallmentsReports />} />
              <Route path="new-connection-status-reports" element={<NewConnectionStatusReport />} />
              <Route path="meter-change-order-status-report" element={<MeterChangeOrderStatusReport />} />
              <Route path="set-aside-table" element={<SetAsideTable />} />
              <Route path="set-aside-form" element={<SetAsideForm />} />
              <Route path="meter-change-request-form" element={<MeterChangeRequestForm />} />
              <Route path="meter-change-request-table" element={<MeterChangeRequestTable showTable={true} />} />
              <Route path="meter-change-request-update" element={<MeterChangeRequestUpdateDocuments />} />
              <Route path="meter-reading-correction-form" element={<MeterReadingCorrectionForm />} />
              <Route path="meter-reading-correction-table" element={<MeterReadingCorrectionTable />} />
              <Route path="meter-reading-update" element={<MeterReadingCorrectionUpdateImages />} />
              <Route path="meter-reading-correction-reports" element={<MeterReadingCorrectionReports />} />
              <Route path="cnic-updation" element={<CNICUpdation />} />
              <Route path="power-complaint-table" element={<PowerComplianTable />} />
              <Route path="power-complaint-form" element={<Powercomplaintsform />} />
              <Route path="power-complaint-tracking" element={<PowercomplaintsTrack />} />
              <Route path="load-shedding-schedule" element={<LoadManagement />} />
              <Route path="duplicate-bill" element={<DuplicateBill />} />
              <Route path="amend-duplicate-bill" element={<AmendDuplicateBill />} />

              <Route path="power-complaint-map" element={<ComplaintsGIS />} />
              <Route path="power-complaint-map-management" element={<ComplaintsGIS />} />
              <Route path="power-complaint-display-complaint" element={<DisplayComplaintGIS />} />
              <Route path="power-complaint-pending" element={<PendingCompliants />} />
              <Route path="power-complaint-allocated" element={<AllocatedComplaints />} />
              <Route path="power-complaint-working" element={<WorkingComplaints />} />
              <Route path="power-complaint-onhold" element={<OnHoldCompliants />} />
              <Route path="power-complaint-escalated" element={<EscalatedComplaints />} />
              <Route path="apms-escalated-complaints" element={<APMSEscalatedComplaints />} />
              <Route path="apms-complaints-summary" element={<APMSComplaintsSummary />} />
              <Route path="power-complaint-resolved" element={<ResolvedComplaints />} />
              <Route path="power-complaint-report" element={<ResolvedComplaints />} />
              <Route path="power-complaint-detail-report" element={<DetailReport />} />
              <Route path="eops-mobile-app-usage-summary" element={<EopsMobileAppUsageSummary />} />
              <Route path="top-best-and-worst-performer-users-report" element={<TopBestAndWorstPerformer />} />
              <Route path="eops-users-status-report" element={<EopsUsersStatus />} />
              <Route path="eops-complaint-source-wise" element={<ComplaintSourceWise />} />

              <Route path="not-logged-in-user-in-last-24-hours" element={<NotLoggedInUserInLast24Hours />} />
              <Route path="lineman-app-user-summary" element={<LinemanAPPUserSummary />} />
              {/* <Route path="mobile-app-stats" element={<MobileAppStats />} /> */}
              <Route path="mobile-app-stats" element={<MobileAppStats/>} />

              <Route path="lineman-staff-performance" element={<LinemanStaffPerformance />} />
              <Route path="subdivision-wise-complaints-summary" element={<ComplaintsSummary />} />
              <Route path="daily-progress-report" element={<DailyProgressReport />} />
              <Route path="feeder-losses-report" element={<FeederLossesReport />} />
              <Route path="dead-defaulter-report" element={<DeadDefaulterList />} />
              <Route path="pending-escalated-complaints" element={<PendingEscalatedTable showTable={true} />} />
              <Route path="cash-collection-summary-report" element={<CashCollectionSummaryReport />} />
              <Route path="batch-wise-assessment-report" element={<BatchWiseAssessmentReport />} />
              <Route path="computed-billing-&-collection-analysis-report" element={<TariffWiseAnalysisOfBillingAndCollectionReport />} />
              <Route path="wrong-reading-table" element={<BatchWiseAssessmentReport />} />
              
            </Route>
          </Route>
          {/* Fallback Route */}
          <Route path="*" element={<Login />} />
        </Routes>
      </BrowserRouter>
    </Grid>
  );
};

export default App;